import { WalkthroughStep } from "./walkthrough-types";

/** How long a walkthrough with a `readySelector` waits before ending unseen. */
export const WALKTHROUGH_READY_TIMEOUT_MS = 30_000;

/** The steps left once `skipIfMissing` highlights with no target are dropped. */
export function presentWalkthroughSteps(
  steps: WalkthroughStep[],
  hasTarget: (selector: string) => boolean,
): WalkthroughStep[] {
  return steps.filter(
    (step) =>
      step.type !== "highlight" ||
      !step.skipIfMissing ||
      hasTarget(step.targetSelector),
  );
}

/** Whether `selector` matches anything; an invalid selector matches nothing. */
export function documentHasTarget(selector: string): boolean {
  try {
    return document.querySelector(selector) != null;
  } catch {
    return false;
  }
}
